import React, { useState, useEffect, useCallback, useRef } from 'react';
import { apiFetch } from '../lib/api';
import { tagClass, statusName, quotaVal, industryLabel } from '../lib/tenant';
import { Icons } from '../components/icons';

export function APIKeysReport() {
  const [overview, setOverview] = useState(null);
  const [trend, setTrend] = useState([]);
  const [topPaths, setTopPaths] = useState([]);
  const [outbound, setOutbound] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    Promise.all([
      apiFetch('/api/v1/platform/api-keys/overview'),
      apiFetch('/api/v1/platform/api-keys/usage-trend?days=14'),
      apiFetch('/api/v1/platform/api-keys/top-paths?limit=10'),
      apiFetch('/api/v1/platform/outbound-logs'),
    ]).then(([o, t, p, ob]) => {
      if (o.code === 0) setOverview(o.data);
      if (t.code === 0) setTrend(t.data?.series || []);
      if (p.code === 0) setTopPaths(p.data || []);
      if (ob.code === 0) setOutbound(ob.data || []);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);
  if (loading) return <div className="empty"><span className="spinner"/></div>;
  const tenants = overview?.tenants || [];
  const maxCalls = Math.max(1, ...trend.map(x => x.calls || 0));
  return <div>
    <div className="stats-grid">
      <div className="stat-card"><div className="stat-value">{overview?.tenant_count ?? 0}</div><div className="stat-label">活跃租户</div></div>
      <div className="stat-card"><div className="stat-value">{overview?.total_keys ?? 0}</div><div className="stat-label">API 密钥数</div></div>
      <div className="stat-card"><div className="stat-value">{overview?.total_calls ?? 0}</div><div className="stat-label">累计调用</div></div>
      <div className="stat-card"><div className="stat-value">{trend.reduce((s,x)=>s+(x.calls||0),0)}</div><div className="stat-label">近14天调用</div></div>
    </div>
    <div className="card" style={{marginBottom:14}}>
      <div className="card-title">近 14 天调用趋势</div>
      {trend.length === 0 ? <p style={{fontSize:13,color:'var(--brand-text-muted)'}}>暂无调用记录</p>
        : <div style={{display:'flex',alignItems:'flex-end',gap:6,height:120}}>
            {trend.map(pt => (
              <div key={pt.day} style={{flex:1,textAlign:'center'}} title={pt.day+': '+pt.calls+' 次'}>
                <div style={{height:Math.max(4, (pt.calls/maxCalls)*100)+'%',background:'var(--brand-primary)',borderRadius:4,marginBottom:4}}/>
                <div style={{fontSize:9,color:'var(--brand-text-muted)'}}>{pt.day.slice(5)}</div>
              </div>
            ))}
          </div>}
    </div>
    <div className="admin-split-grid">
      <div className="card" style={{padding:0}}>
        <div className="card-title" style={{padding:'14px 16px 0'}}>租户 API 调用排行</div>
        <div className="table-wrap">
          <table className="admin-table"><thead><tr><th className="col-name">租户</th><th className="col-num">密钥</th><th className="col-num">调用</th><th className="col-date">最近</th></tr></thead>
            <tbody>{tenants.length===0 ? <tr><td colSpan={4} className="cell-wrap" style={{textAlign:'center',padding:20,color:'var(--brand-text-muted)'}}>暂无数据</td></tr>
              : tenants.map(t => (
                <tr key={t.tenant_id}>
                  <td className="col-name cell-wrap"><strong>{t.tenant_name}</strong><div className="cell-sub">{t.tenant_code}</div></td>
                  <td className="col-num">{t.key_count}</td>
                  <td className="col-num">{t.total_calls}</td>
                  <td className="col-date cell-muted">{t.last_used_at ? new Date(t.last_used_at).toLocaleString() : '—'}</td>
                </tr>
              ))}</tbody>
          </table>
        </div>
      </div>
      <div className="card" style={{padding:0}}>
        <div className="card-title" style={{padding:'14px 16px 0'}}>热门 API 路径 (30天)</div>
        <div className="table-wrap">
          <table className="admin-table"><thead><tr><th className="col-shrink">方法</th><th className="col-path">路径</th><th className="col-num">次数</th><th className="col-num">错误</th></tr></thead>
            <tbody>{topPaths.map((p,i) => (
              <tr key={i}><td><span className="tag tag-blue">{p.method}</span></td><td className="col-path" title={p.path}>{p.path}</td><td className="col-num">{p.calls}</td><td className="col-num">{p.errors||0}</td></tr>
            ))}</tbody>
          </table>
        </div>
      </div>
    </div>
    <div className="card" style={{marginTop:14,padding:0}}>
      <div className="card-title" style={{padding:'14px 16px 0'}}>外发通知日志（邮件/短信/Webhook）</div>
      <div className="table-wrap">
        <table className="admin-table"><thead><tr><th className="col-date">时间</th><th className="col-status">渠道</th><th className="col-name">收件人</th><th>主题</th><th className="col-status">状态</th></tr></thead>
          <tbody>{outbound.length===0 ? <tr><td colSpan={5} className="cell-wrap" style={{textAlign:'center',padding:20,color:'var(--brand-text-muted)'}}>暂无外发记录</td></tr>
            : outbound.map(o => (
              <tr key={o.id}>
                <td className="col-date cell-muted">{new Date(o.created_at).toLocaleString()}</td>
                <td className="col-status"><span className="tag tag-gray">{o.channel}</span></td>
                <td className="col-name cell-muted">{o.recipient}</td>
                <td className="cell-muted">{o.subject}</td>
                <td className="col-status"><span className={'tag '+(o.status==='sent'?'tag-green':'tag-orange')}>{o.status}</span></td>
              </tr>
            ))}</tbody>
        </table>
      </div>
    </div>
  </div>;
}

